import getCountryISO2 from 'country-iso-3-to-2';

/**
 * Normalises a country code into an ISO 3166-1 alpha-2 (2-letter) code.
 *
 * The API in Nightgraph is inconsistent: `event.club.city.country.isoCode` is returned as
 * alpha-2 (e.g. `PT`), while `clubState.city.country.isoCode` (CompanyClubContext) is
 * returned as alpha-3 (e.g. `PRT`). Backend endpoints expect alpha-2.
 *
 * @param isoCode The ISO code from the API. May be alpha-2, alpha-3, empty or undefined.
 * @returns An alpha-2 code when the input is a valid alpha-2 or alpha-3 code, otherwise `undefined`.
 */
export const countryIsoToIso2 = (isoCode?: string | null): string | undefined => {
  if (!isoCode) return undefined;
  const normalised = isoCode.trim().toUpperCase();
  if (normalised.length === 2) return normalised;
  if (normalised.length === 3) return getCountryISO2(normalised);
  return undefined;
};
